<template>
  <media-menu>
    <!-- Menu Button -->
    <VideoPlayerTooltip :placement="tooltipPlacement">
      <template #trigger>
        <media-menu-button
          class="relative inline-flex aria-hidden:hidden h-10 w-10 cursor-pointer items-center justify-center rounded-md outline-none ring-inset group ring-media-focus mr-0.5 hover:bg-white/20 data-[focus]:ring-4"
        >
          <slot name="button"/>
        </media-menu-button>
      </template>
      <template #content>
        <slot name="tooltip-content"/>
      </template>
    </VideoPlayerTooltip>

    <!-- Menu Items -->
    <media-menu-items :style="maxHeightStyle"
      class="animate-out hide-scrollbar fade-out slide-out-to-bottom-2 data-[open]:animate-in data-[open]:fade-in data-[open]:slide-in-from-bottom-4 flex h-[var(--menu-height)] min-w-[260px] flex-col overflow-y-auto overscroll-y-contain rounded-md border border-white/10 bg-black/95 p-2.5 font-sans text-[15px] font-medium outline-none backdrop-blur-sm transition-[height] duration-300 will-change-[height] data-[resizing]:overflow-hidden"
      :placement="placement"
    >
      <slot name="content"/>
    </media-menu-items>

  </media-menu>
</template>

<script setup>
import VideoPlayerTooltip from "./VideoPlayerTooltip.vue";
import {computed} from "vue";

const props = defineProps({
  isSmall: Boolean,
  placement: {
    type: String,
    default: "top",
  },
  tooltipPlacement: {
    type: String,
    default: "top",
  },
});

const maxHeightStyle = computed(() => {
  if (props.isSmall) return "max-height: 150px;";
  return "max-height: 400px;";

});
</script>
